(function($){
    $(document).ready(function() {

        // Header slider constructor
        var SlickSliderInit = function(elem,sliderPaprms) {
            var self = this;
            this.wrapper = elem;
            this.sliderParams = sliderPaprms || {};

            this._sliderInit = function() {
                self.wrapper.slick(this.sliderParams);
            };

            this.init = function() {
                self._sliderInit();
            };

            this.init();
        };

        // Partners slider constructor
        // ToDo: create js class and implement inheritance
        var SlickSliderInitPartners = function(elem,sliderPaprms) {
            var self = this;
            this.wrapper = elem;
            this.sliderParams = sliderPaprms || {};

            this._sliderInit = function() {
                self.wrapper.slick(this.sliderParams);
            };

            this.init = function() {
                self._sliderInit();
            };

            this.init();
        };

        // Project slider constructor
        // ToDo: create js class and implement inheritance
        var SlickSliderInitProject = function(sliderFor,sliderNav,sliderForParams,sliderNavParams) {
            var self = this;
            this.sliderWrapper = sliderFor.closest('.js-project-slider');
            this.banners = sliderFor.find('.banner_wrapper');
            this.categoryColor = sliderFor.closest('.js-project-inner').attr('data-colour');
            this.options = {
                sliderForOptions: sliderForParams || {

                },
                sliderNavOptions:sliderNavParams || {

                }
            };

            this._collectImageLinks = function() {
                self.banners.each(function(key,value) {
                    sliderFor.append('<div class="project-slide"><img src="' + $(value).find('img').attr('src') + '" alt=""></div>');
                    sliderNav.append('<div class="project-slide"><img src="' + $(value).find('img').attr('src') + '" alt=""></div>');
                });
            };

            this._removeBanners = function() {
                sliderFor.find('.banner_wrapper').remove();
                sliderNav.find('.banner_wrapper').remove();
            };

            this._setNavSliderImages = function() {
                sliderNav.find('.project-slide').each(function(key,value) {
                    $(value).css('background-image','url(' + $(value).find('img').attr('src') + ')');
                });
                sliderNav.find('img').remove();
            };

            this._initForSlider = function() {
                sliderFor.slick(self.options.sliderForOptions);
            };

            this._initNavSlider = function() {
                sliderNav.slick(self.options.sliderNavOptions);
            };

            this._setCategoryColor = function() {
                sliderFor.css('border-top-color',this.categoryColor);
                sliderNav.css('border-bottom-color',this.categoryColor);
                self.sliderWrapper.find('.slick-arrow').css('background-color',this.categoryColor);
                self.sliderWrapper.find('.slick-arrow.slick-next').css('border-right-color',this.categoryColor);
                self.sliderWrapper.find('.slick-arrow.slick-prev').css('border-left-color',this.categoryColor);
            };

            this._setArrowsHover = function() {
                self.sliderWrapper.find('.slick-arrow').each(function(key,value) {
                    $(value).on('mouseenter',function() {
                        $(value).css('background-color','#ffffff');
                        $(value).css('border-color',self.categoryColor);
                        $(value).find('i').css('color',self.categoryColor);
                    });
                    $(value).on('mouseleave',function() {
                        $(value).css('background-color',self.categoryColor);
                        $(value).css('border-color','#ffffff');
                        if($(value).hasClass('slick-next')) {
                            $(value).css('border-right-color',self.categoryColor);
                        } else {
                            $(value).css('border-left-color',self.categoryColor);
                        }
                        $(value).find('i').css('color','#ffffff');
                    });
                });
            };

            this.init = function() {
                self._collectImageLinks();
                self._removeBanners();
                self._setNavSliderImages();
                self._initForSlider();
                self._initNavSlider();
                self._setCategoryColor();
                self._setArrowsHover();
            };
            this.init();
        };

        // init header slider
        var homeSlider = new SlickSliderInit($(".banners"),{
            slidesToShow: 1,
            autoplay:true,
            autoplaySpeed:5000,
            dots:false,
            fade:true,
            prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow:'<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
            speed:500,
            pauseOnDotsHover:true,
            pauseOnHover:false,
            adaptiveHeight:true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows:false
                }
            }]
        });

        // init partners slider
        var partnersSlider = new SlickSliderInitPartners($(".js-partners-slider"),
            {
                slidesToShow: 5,
                slidesToScroll: 5,
                autoplay:false,
                autoplaySpeed:5000,
                arrows:false,
                dots:true,
                speed:500,
                pauseOnDotsHover:true,
                adaptiveHeight:true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },{
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }]
            }
        );

        // init project slider
        var projectSlider = new SlickSliderInitProject($('.js-project-slider-for'),$('.js-project-slider-nav'),{
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow:'<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
            adaptiveHeight:true,
            asNavFor: '.js-project-slider-nav',
            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows: false,
                }
            }]
        },{
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.js-project-slider-for',
            focusOnSelect: true,
            prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow:'<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }]
        });
    });
})(jQuery);

